import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Gift, Share2 } from "lucide-react";
import { useAccount } from "@/lib/account";

export default function Invite() {
  const { authed } = useAccount();
  const [info, setInfo] = useState(null);
  useEffect(() => { authed("get", "/referral").then(setInfo).catch(() => {}); }, [authed]);
  const link = info ? `${window.location.origin}/?ref=${info.ref_code}` : "";
  const msg = `I found Vivaah Royale – an affordable matrimony site. Trial from just ₹9! Join with my link and we both get ₹10 chat credit: ${link}`;
  const copy = () => { navigator.clipboard.writeText(link); toast.success("Link copied"); };
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-14" data-testid="invite-page">
      <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold">Invite & earn</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold mt-3">Share the joy, earn chat credit</h1>
      <p className="text-slate-400 mt-4">Invite friends, cousins and family members looking for a match. When they buy any plan, you <b className="text-amber-200">both get ₹{info?.bonus ?? 10}</b> wallet credit.</p>
      <div className="card-royal rounded-3xl p-8 mt-10 grain relative overflow-hidden">
        <Gift className="w-8 h-8 text-amber-400" />
        <p className="text-xs uppercase tracking-widest text-slate-400 mt-6">Your invite code</p>
        <p className="font-display text-5xl gold-text mt-1" data-testid="invite-code">{info?.ref_code || "…"}</p>
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <input readOnly value={link} className="field text-sm" data-testid="invite-link-input" />
          <button onClick={copy} data-testid="invite-copy-button" className="btn-ghost px-5 py-3 rounded-xl flex items-center gap-2 justify-center shrink-0"><Copy className="w-4 h-4" /> Copy</button>
          <a href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="invite-whatsapp-button" className="btn-gold px-5 py-3 rounded-xl flex items-center gap-2 justify-center shrink-0"><Share2 className="w-4 h-4" /> WhatsApp</a>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-8">
          <div className="border-l border-amber-500/40 pl-4"><div className="font-display text-3xl" data-testid="invite-joined">{info?.joined ?? 0}</div><div className="text-xs text-slate-400 uppercase tracking-widest">Joined</div></div>
          <div className="border-l border-amber-500/40 pl-4"><div className="font-display text-3xl" data-testid="invite-rewarded">{info?.rewarded ?? 0}</div><div className="text-xs text-slate-400 uppercase tracking-widest">Rewards earned</div></div>
        </div>
      </div>
    </div>
  );
}
